export const styles = () => ({
  contentWrapper: { padding: '0px 25px' },
  bluePrimaryBackground: { backgroundColor: '#e5f0ff' },
  imagesContainer: { position: 'relative' },
  logoWrapper: { position: 'absolute', height: '100%' },
  logo: { height: '70%', marginLeft: '40px', borderRadius: '50%' },
});
